module.exports = __webpack_public_path__ + "static/media/align-left.4dd59e5b.svg";